import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

import en from './locales/en.json'
import es from './locales/es.json'

// Get language from localStorage, default to Spanish ('es')
let lang = localStorage.getItem('lang') || 'es'

// Validate language is supported
if (!['en', 'es'].includes(lang)) {
  lang = 'es'
}

const i18n = new VueI18n({
  locale: lang,
  messages: {
    en,
    es
  }
})

export default i18n
